import React, { useContext, useState } from 'react';
import { Navbar, Container, Nav, NavDropdown, Offcanvas, ButtonGroup, Button, Collapse } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FaHome, FaUserInjured, FaUserMd, FaPills, FaFileMedical, FaUsers, FaCog, FaCalendarCheck, FaFileInvoiceDollar, FaListOl, FaDatabase, FaSignOutAlt, FaDumbbell, FaUserFriends, FaClipboardCheck, FaCreditCard, FaBoxOpen, FaRunning, FaChartBar, FaMoneyBillWave, FaChevronDown, FaChevronRight, FaReceipt } from 'react-icons/fa';
import { BsQrCodeScan } from 'react-icons/bs';
import AuthContext from '../../context/AuthContext';
import { AppModeContext } from '../../context/AppModeContext';

const MainNavbar = ({ clinic }) => {
  const { user, logout } = useContext(AuthContext);
  const { appMode, toggleMode } = useContext(AppModeContext);
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);
  const [reportsOpen, setReportsOpen] = useState(false);
  const [financeOpen, setFinanceOpen] = useState(false);
  const [expensesOpen, setExpensesOpen] = useState(false);
  const [adminOpen, setAdminOpen] = useState(false);
  const [gymMembersOpen, setGymMembersOpen] = useState(false);
  const [gymOperationsOpen, setGymOperationsOpen] = useState(false);
  const [gymReportsOpen, setGymReportsOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const permissions = user?.role === 'admin' ? {} : (user?.permissions || {});
  const isAdmin = user?.role === 'admin';
  
  const hasPermission = (key) => {
    return isAdmin || permissions[key] === true;
  };

  return (
    <>
    <Navbar style={{ backgroundColor: '#1e88e5', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }} variant="dark" expand="md">
      <Container fluid>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center" style={{ fontSize: '1.1rem' }}>
          {clinic.logo ? (
            <img
              src={clinic.logo}
              alt={clinic.name}
              height="40"
              className="d-inline-block align-top me-2"
            />
          ) : (
            <>
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-hospital me-2" viewBox="0 0 16 16">
                <path d="M8.5 5.034v1.1l.953-.55.5.867L9 7l.953.55-.5.866-.953-.55v1.1h-1v-1.1l-.953.55-.5-.866L7 7l-.953-.55.5-.866.953.55v-1.1h1ZM13.25 9a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5ZM13 11.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5Zm.25 1.75a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5Zm-11-4a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 3 9.75v-.5A.25.25 0 0 0 2.75 9h-.5Zm0 2a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5ZM2 13.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5Z"/>
                <path d="M5 1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 1 1v4h3a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1V1Zm2 14h2v-3H7v3Zm3 0h1V3H5v12h1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3Zm0-14H6v1h4V1Zm2 7v7h3V8h-3Zm-8 7V8H1v7h3Z"/>
              </svg>
              {clinic.name}
            </>
          )}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="d-none" />
        <button 
          className="navbar-toggler d-md-none" 
          type="button" 
          onClick={() => setShowSidebar(true)}
          style={{ border: 'none', background: 'transparent' }}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <Navbar.Collapse id="basic-navbar-nav" className="d-none d-md-flex">
          <Nav className="ms-auto">
            {user ? (
              <>
                <NavDropdown 
                  title={
                    <span className="text-white">
                      {user.username}
                    </span>
                  } 
                  id="user-dropdown"
                  align="end"
                >
                  <div className="px-3 py-2 text-center">
                    <p className="mb-0 fw-bold">{user.username}</p>
                    <p className="text-muted small mb-0">{user.email}</p>
                    <div className="mt-1 mb-2">
                      <span className="badge bg-primary">{user.role}</span>
                    </div>
                  </div>
                  <NavDropdown.Divider />
                  <NavDropdown.Item as={Link} to="/profile">
                    <span className="bi bi-person-gear me-2"></span> Edit Profile
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item onClick={handleLogout}>
                    <span className="bi bi-box-arrow-right me-2"></span> Logout
                  </NavDropdown.Item>
                </NavDropdown>
              </>
            ) : (
              <Nav.Link as={Link} to="/login" className="text-white">
                Login
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>

    <Offcanvas show={showSidebar} onHide={() => setShowSidebar(false)} placement="start" style={{ backgroundColor: '#0d47a1', color: '#fff' }}>
      <Offcanvas.Header closeButton closeVariant="white">
        <Offcanvas.Title style={{ color: '#fff' }}>{clinic.name}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {/* Mode Switch */}
        <div className="mb-3">
          <ButtonGroup className="w-100">
            <Button
              variant={appMode === 'clinic' ? 'light' : 'outline-light'}
              size="sm"
              onClick={() => toggleMode('clinic')}
            >
              🏥 Clinic
            </Button>
            <Button
              variant={appMode === 'gym' ? 'light' : 'outline-light'}
              size="sm"
              onClick={() => toggleMode('gym')}
            >
              🏋️ Gym
            </Button>
          </ButtonGroup>
        </div>
        
        <Nav className="flex-column">
          {appMode === 'clinic' ? (
            // Clinic Menu
            <>
              {hasPermission('dashboard') && (
                <Nav.Link as={Link} to="/" onClick={() => setShowSidebar(false)} className="text-white py-3">
                  <FaHome className="me-2" /> Dashboard
                </Nav.Link>
              )}
              {hasPermission('patients') && (
                <Nav.Link as={Link} to="/patients" onClick={() => setShowSidebar(false)} className="text-white py-3">
                  <FaUserInjured className="me-2" /> Patients
                </Nav.Link>
              )}
              {hasPermission('doctors') && (
                <Nav.Link as={Link} to="/doctors" onClick={() => setShowSidebar(false)} className="text-white py-3">
                  <FaUserMd className="me-2" /> Doctors
                </Nav.Link>
              )}
              {hasPermission('appointments') && (
                <Nav.Link as={Link} to="/appointments" onClick={() => setShowSidebar(false)} className="text-white py-3">
                  <FaCalendarCheck className="me-2" /> Appointments
                </Nav.Link>
              )}
              {hasPermission('onlineAppointments') && (
                <Nav.Link as={Link} to="/online-appointments" onClick={() => setShowSidebar(false)} className="text-white py-3">
                  <FaCalendarCheck className="me-2" /> Online Appointments
                </Nav.Link>
              )}
              {hasPermission('queue') && (
                <Nav.Link as={Link} to="/queue" onClick={() => setShowSidebar(false)} className="text-white py-3">
                  <FaListOl className="me-2" /> Patient Queue
                </Nav.Link>
              )}
              {hasPermission('medicines') && (
                <Nav.Link as={Link} to="/medicines" onClick={() => setShowSidebar(false)} className="text-white py-3">
                  <FaPills className="me-2" /> Medicines
                </Nav.Link>
              )}
              {(hasPermission('reports') || hasPermission('appointmentReports')) && (
                <>
                  <div className="border-top border-secondary my-2"></div>
                  
                  <div
                    onClick={() => setReportsOpen(!reportsOpen)}
                    className="text-white py-3"
                    style={{ cursor: 'pointer', padding: '0.75rem 1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                  >
                    <span style={{ flex: 1, minWidth: 0 }}>
                      <FaFileMedical className="me-2" /> Medical Reports & Billing
                    </span>
                    {reportsOpen ? <FaChevronDown style={{ marginLeft: '8px' }} /> : <FaChevronRight style={{ marginLeft: '8px' }} />}
                  </div>
                  
                  <Collapse in={reportsOpen}>
                    <div>
                      {hasPermission('reports') && (
                        <Nav.Link as={Link} to="/reports" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                          <FaFileMedical className="me-2" /> Medical Reports
                        </Nav.Link>
                      )}
                      {hasPermission('appointmentReports') && (
                        <Nav.Link as={Link} to="/appointment-reports" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                          <FaCalendarCheck className="me-2" /> Appointment Reports
                        </Nav.Link>
                      )}
                    </div>
                  </Collapse>
                </>
              )}
              
              {(hasPermission('billing') || hasPermission('deposits') || hasPermission('financialReports') || hasPermission('expenses') || hasPermission('salaries')) && (
                <>
                  <div
                    onClick={() => setFinanceOpen(!financeOpen)}
                    className="text-white py-3"
                    style={{ cursor: 'pointer', padding: '0.75rem 1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                  >
                    <span style={{ flex: 1, minWidth: 0 }}>
                      <FaFileInvoiceDollar className="me-2" /> Finance
                    </span>
                    {financeOpen ? <FaChevronDown style={{ marginLeft: '8px' }} /> : <FaChevronRight style={{ marginLeft: '8px' }} />}
                  </div>
                  
                  <Collapse in={financeOpen}>
                    <div>
                      {hasPermission('billing') && (
                        <Nav.Link as={Link} to="/billing" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                          <FaFileInvoiceDollar className="me-2" /> Billing
                        </Nav.Link>
                      )}
                      {hasPermission('deposits') && (
                        <Nav.Link as={Link} to="/doctor-payments" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                          <FaMoneyBillWave className="me-2" /> Deposit Collection
                        </Nav.Link>
                      )}
                      {hasPermission('financialReports') && (
                        <Nav.Link as={Link} to="/financial-reports" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                          <FaChartBar className="me-2" /> Financial Reports
                        </Nav.Link>
                      )}
                      
                      {hasPermission('expenses') && (
                        <>
                          <div
                            onClick={() => setExpensesOpen(!expensesOpen)}
                            className="text-white py-2 ps-4"
                            style={{ cursor: 'pointer', padding: '0.5rem 1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                          >
                            <span style={{ flex: 1, minWidth: 0 }}>
                              <FaReceipt className="me-2" /> Expenses
                            </span>
                            {expensesOpen ? <FaChevronDown style={{ marginLeft: '8px' }} /> : <FaChevronRight style={{ marginLeft: '8px' }} />}
                          </div>
                          
                          <Collapse in={expensesOpen}>
                            <div>
                              <Nav.Link as={Link} to="/expense-types" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-5">
                                <FaReceipt className="me-2" /> Expense Types
                              </Nav.Link>
                              <Nav.Link as={Link} to="/expenses" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-5">
                                <FaReceipt className="me-2" /> Expense Records
                              </Nav.Link>
                            </div>
                          </Collapse>
                        </>
                      )}
                      
                      {hasPermission('salaries') && (
                        <Nav.Link as={Link} to="/doctor-salaries" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                          <FaMoneyBillWave className="me-2" /> Doctor Salaries
                        </Nav.Link>
                      )}
                    </div>
                  </Collapse>
                </>
              )}
            </>
          ) : (
            // Gym Menu
            <>
              <Nav.Link as={Link} to="/gym/dashboard" onClick={() => setShowSidebar(false)} className="text-white py-3">
                <FaHome className="me-2" /> Dashboard
              </Nav.Link>
              <div className="border-top border-secondary my-2"></div>
              
              <div
                onClick={() => setGymMembersOpen(!gymMembersOpen)}
                className="text-white py-3"
                style={{ cursor: 'pointer', padding: '0.75rem 1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <span style={{ flex: 1, minWidth: 0 }}>
                  <FaUserFriends className="me-2" /> Members Management
                </span>
                {gymMembersOpen ? <FaChevronDown style={{ marginLeft: '8px' }} /> : <FaChevronRight style={{ marginLeft: '8px' }} />}
              </div>
              
              <Collapse in={gymMembersOpen}>
                <div>
                  <Nav.Link as={Link} to="/gym/members" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                    <FaUserFriends className="me-2" /> All Members
                  </Nav.Link>
                  <Nav.Link as={Link} to="/gym/memberships" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                    <FaCreditCard className="me-2" /> Memberships
                  </Nav.Link>
                  <Nav.Link as={Link} to="/gym/packages" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                    <FaBoxOpen className="me-2" /> Packages
                  </Nav.Link>
                </div>
              </Collapse>
              
              <div
                onClick={() => setGymOperationsOpen(!gymOperationsOpen)}
                className="text-white py-3"
                style={{ cursor: 'pointer', padding: '0.75rem 1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <span style={{ flex: 1, minWidth: 0 }}>
                  <FaClipboardCheck className="me-2" /> Daily Operations
                </span>
                {gymOperationsOpen ? <FaChevronDown style={{ marginLeft: '8px' }} /> : <FaChevronRight style={{ marginLeft: '8px' }} />}
              </div>
              
              <Collapse in={gymOperationsOpen}>
                <div>
                  <Nav.Link as={Link} to="/gym/qr-scanner" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                    <BsQrCodeScan className="me-2" /> QR Scanner
                  </Nav.Link>
                  <Nav.Link as={Link} to="/gym/attendance" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                    <FaClipboardCheck className="me-2" /> Attendance
                  </Nav.Link>
                  <Nav.Link as={Link} to="/gym/trainers" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                    <FaDumbbell className="me-2" /> Trainers
                  </Nav.Link>
                  <Nav.Link as={Link} to="/gym/workout-plans" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                    <FaRunning className="me-2" /> Workout Plans
                  </Nav.Link>
                </div>
              </Collapse>
              
              <div
                onClick={() => setGymReportsOpen(!gymReportsOpen)}
                className="text-white py-3"
                style={{ cursor: 'pointer', padding: '0.75rem 1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <span style={{ flex: 1, minWidth: 0 }}>
                  <FaChartBar className="me-2" /> Finance & Reports
                </span>
                {gymReportsOpen ? <FaChevronDown style={{ marginLeft: '8px' }} /> : <FaChevronRight style={{ marginLeft: '8px' }} />}
              </div>
              
              <Collapse in={gymReportsOpen}>
                <div>
                  <Nav.Link as={Link} to="/gym/payments" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                    <FaMoneyBillWave className="me-2" /> Payments
                  </Nav.Link>
                  <Nav.Link as={Link} to="/gym/expenses" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                    <FaFileInvoiceDollar className="me-2" /> Expenses
                  </Nav.Link>
                  <Nav.Link as={Link} to="/gym/reports" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                    <FaChartBar className="me-2" /> Reports
                  </Nav.Link>
                </div>
              </Collapse>
            </>
          )}
          {user && user.role === 'admin' && (
            <>
              <div className="border-top border-secondary my-2"></div>
              
              <div
                onClick={() => setAdminOpen(!adminOpen)}
                className="text-white py-3"
                style={{ cursor: 'pointer', padding: '0.75rem 1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <span style={{ flex: 1, minWidth: 0 }}>
                  <FaCog className="me-2" /> Administration
                </span>
                {adminOpen ? <FaChevronDown style={{ marginLeft: '8px' }} /> : <FaChevronRight style={{ marginLeft: '8px' }} />}
              </div>
              
              <Collapse in={adminOpen}>
                <div>
                  <Nav.Link as={Link} to="/users" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                    <FaUsers className="me-2" /> Users
                  </Nav.Link>
                  <Nav.Link as={Link} to="/register" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                    <FaUsers className="me-2" /> Register User
                  </Nav.Link>
                  <Nav.Link as={Link} to="/roles" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                    <FaUsers className="me-2" /> Manage Roles
                  </Nav.Link>
                  <Nav.Link as={Link} to="/settings" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                    <FaCog className="me-2" /> Settings
                  </Nav.Link>
                  <Nav.Link as={Link} to="/backup" onClick={() => setShowSidebar(false)} className="text-white py-2 ps-4">
                    <FaDatabase className="me-2" /> Backup & Restore
                  </Nav.Link>
                </div>
              </Collapse>
            </>
          )}
          <div className="border-top border-secondary my-2"></div>
          <Nav.Link onClick={() => { handleLogout(); setShowSidebar(false); }} className="text-white py-3" style={{ color: '#ef4444 !important', cursor: 'pointer' }}>
            <FaSignOutAlt className="me-2" /> Logout
          </Nav.Link>
        </Nav>
      </Offcanvas.Body>
    </Offcanvas>
    </>
  );
};

export default MainNavbar; 